/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
/* eslint-disable no-mixed-operators  */
import React, {
  Fragment,
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback
} from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { format } from 'date-fns';
import { useTranslation } from "react-i18next";

import { sessionsReducer } from "app/utils";
import {
  useUtils,
  useUrlParams,
  useLocationUrlReplace,
  useDateUrlReplace,
  useRouter
  , useConfig, useDateSelector, useLocationSelector
} from "app/hooks";
import { WithMoviesWatchlistBtn, ButtonWatchlist } from "app/modules/watchlist";
import {
  Svg,
  NavTabs,
  ModalCarousel,
  Player,
  Container,
  TitleWithPoster,
  NoContent,
  MoviesDatesFilter
} from "app/components";
import {
  MainEntityDetails,
  SectionEntityDetails,
  EntityGallery
} from "app/components/Entity";

import { useLocation } from "react-router-dom";
import useEventMovieSessions from "./hooks/useEventMovieSessions";
import useDailyMovieSessions from "./hooks/useDailyMovieSessions";

import AsideMovieDetails from "./components/Aside";
import CommonView from "./components/CommonView";
import DailySessionView from "./components/DailySessionsView";
import CinemaSessionsView from "./components/CinemaSessionsView";

import Aside from "./components/Aside";
import VideoPoster from "./components/VideoPoster";
import { PosterMovieDetails } from "./styles";

const { NavTabsList, NavTabsItem } = NavTabs;

const WatchListBtn = WithMoviesWatchlistBtn(ButtonWatchlist);

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    }).isRequired
  }).isRequired,
  movieDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.any])
    .isRequired,
  sessions: PropTypes.oneOfType([PropTypes.array, PropTypes.any]).isRequired,
  daysSessions: PropTypes.arrayOf(PropTypes.object).isRequired,
  dates: PropTypes.arrayOf(PropTypes.string).isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  savedLocation: PropTypes.string.isRequired,
  savedCinema: PropTypes.string.isRequired,

  getMovie: PropTypes.func.isRequired,
  getDateList: PropTypes.func.isRequired,
  getSessions: PropTypes.func.isRequired,

  setMovie: PropTypes.func.isRequired,
  setSessions: PropTypes.func.isRequired,
  setDaysSessions: PropTypes.func.isRequired,
  setDateList: PropTypes.func.isRequired,
  moviesFilterSuccess: PropTypes.func.isRequired,
  findMovie: PropTypes.func.isRequired,
  findMoviefilter: PropTypes.func.isRequired,
  eventsWebFetch: PropTypes.func.isRequired,
  eventWeb: PropTypes.array.isRequired,

  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  cinemas: PropTypes.arrayOf(PropTypes.object).isRequired,
  saveLocation: PropTypes.func.isRequired,
  history: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
    replace: PropTypes.func.isRequired
  }).isRequired,
};

const PAGE_TYPES = {
  COMMON: "COMMON",
  DAILY_SESSIONS: "DAILY_SESSIONS",
  CINEMA_SESSIONS: "CINEMA_SESSIONS",
  EVENT_SESSIONS: "EVENT_SESSIONS"
};

const MovieDetails = ({
  match,
  dates,
  sessions,
  daysSessions,
  movieDetails,
  isLoggedIn,
  savedLocation,
  savedCinema,

  getMovie,
  getDateList,
  getSessions,

  setMovie,
  setSessions,
  setCinemas,
  setDateList,
  moviesFilterSuccess,
  findMovie,
  findMoviefilter,
  eventsWebFetch,
  eventWeb,
  setDaysSessions,
  locations,
  cinemas,
  saveLocation,
  history
}) => {
  const [t, i18n] = useTranslation();
  const { id: movieName } = match.params;
  const urlSearchParams = new URLSearchParams(history.location.search);
  const searchedMovies = useSelector(state => state.search.movies);
  const filteredMovies = useSelector(state => state.movies.movieFilterDetails);
  const filteredUpcomingMovies = useSelector(state => state.movies.upcomingMovieFilterDetails);
  const selectedMovie = filteredMovies?.[0]?.master ?
    (
      filteredMovies?.length && filteredMovies?.find(
        item => {
          if (item?.master?.titleCalculated?.toLowerCase()?.replaceAll(/[.\s]/g, "-") === movieName.toLowerCase()) {
            return item?.master?.titleCalculated?.toLowerCase()?.replaceAll(/[.\s]/g, "-") === movieName.toLowerCase()
          }
          if (item?.master?.shortURL) {
            return item?.master?.shortURL === movieName.toLowerCase()
          }

          return item?.master?.titleOriginalCalculated?.toLowerCase()?.replaceAll(/[.\s]/g, "-") === movieName.toLowerCase()

        }
      ))
    : filteredMovies?.length && filteredMovies?.find(
      item => {
        if (item?.titleCalculated?.toLowerCase()?.replaceAll(/[.\s]/g, "-") === movieName.toLowerCase()) {
          return item?.titleCalculated?.toLowerCase()?.replaceAll(/[.\s]/g, "-") === movieName.toLowerCase()
        }
        if (item?.shortURL) {
          return item?.shortURL === movieName.toLowerCase()
        }

        return item?.titleOriginalCalculated?.toLowerCase()?.replaceAll(/[.\s]/g, "-") === movieName.toLowerCase()

      }
    );
  const {
    location: { state }
  } = useRouter();
  const movieIdRef = useRef(state?.movieId);
  const [shortURL, setShortURL] = useState('');
  const { date, location, cinemaId, daily, eventId, sessionId, event } = useUrlParams(
    "date",
    "location",
    "cinemaId",
    "daily",
    "eventId",
    "sessionId",
    "event"
  );
  const { pathname, search } = useLocation();

  useEffect(() => {
    // let pathname = window.location.pathname;
    if (selectedMovie !== undefined && movieName !== selectedMovie?.titleCalculated?.replaceAll(' ', '-')) {
      // let newPathName = pathname.replace(pathname.split('/')[2], selectedMovie?.titleCalculated.replaceAll(' ', '-'));
      // let newPath = window.location.href.replace(pathname, newPathName);
      // window.location.replace(newPath)
    }
    setShortURL(movieDetails?.shortURL)
  }, [movieDetails, shortURL])
  const { getDateWithOffset, getFallbackDate } = useUtils();
  const [isMainTabVisible, toggleTabs] = useState(true);
  const [eventWebData, setEventWebData] = useState(eventWeb);


  const cinemasWithTickets = useMemo(() => {
    if (!sessions || !sessions.length) {
      return [];
    }

    return Object.values(
      sessionsReducer(sessions[0].sessions, getDateWithOffset, true)
    );
  }, [sessions]);

  const searchMovieId = localStorage.getItem("searchMovieId")
  const pageType = useMemo(() => {
    let type = null;

    if (daily || eventId) {
      type = PAGE_TYPES.DAILY_SESSIONS;
    } else if (date && location && cinemaId && !event) {
      type = PAGE_TYPES.CINEMA_SESSIONS;
    } else if (date && location && event) {
      type = PAGE_TYPES.EVENT_SESSIONS
    } else if (date && location) {
      type = PAGE_TYPES.COMMON;
    }

    return type;

  }, [date, location, cinemaId, daily, eventId, event, searchMovieId]);

  const cinemaSessions = useMemo(
    () => cinemasWithTickets.find(c => c.cinemaId === cinemaId),
    [cinemaId, cinemasWithTickets]
  );

  const [redLabelLocation, setRedLabelLocation] = useState(false);
  const [redLabelCinema, setRedLabelCinema] = useState(false);
  const [selectCinemaIdvalue, setSelectCinemaIdvalue] = useState('');
  const [searchCinemaIdvalue, setSearchCinemaIdvalue] = useState('');
  const [sessionCheckLength, setSessionCheckLength] = useState('');
  const [EventSessionCheckLength, setEventSessionCheckLength] = useState('');

  const oldURL = document.referrer;

  const selectCinemaId = sessionStorage.getItem('cinemaId')
  // const selectMovieId = localStorage.getItem("selectMovieId");
  const selectMovieId = selectedMovie?.id === localStorage.getItem("selectMovieId") ? localStorage.getItem("selectMovieId") : selectedMovie?.id;
  const selectEventMovieId = sessionStorage.getItem("seletEventMovieId");

  const { isDateValid, isDateExist, onDateSelected } = useDateUrlReplace(dates);
  const { onLocationSelected } = useLocationUrlReplace();

  useEventMovieSessions(eventId, movieIdRef.current);
  // ! 3
  // console.log("daily && movieIdRef.current || searchMovieId || filteredMovies?.id || selectMovieId,|| selectedMovie?.id", movieIdRef?.current, searchMovieId, filteredMovies?.id, selectMovieId, selectedMovie?.id)
  // useDailyMovieSessions({ movieId: daily && movieIdRef.current || searchMovieId || selectMovieId, location });
  useDailyMovieSessions({ movieId: daily && movieIdRef.current || searchMovieId || filteredMovies?.id || filteredUpcomingMovies?.id || selectMovieId || selectedMovie?.id, location });


  useEffect(
    () => () => {
      setMovie([]);
      setSessions([]);
      setDateList([]);
      moviesFilterSuccess([]);
      setCinemas();
      setDaysSessions([]);
    },
    []
  );

  useEffect(() => {
    if (state?.movieId || searchMovieId || filteredMovies?.id || filteredUpcomingMovies?.id || selectEventMovieId || selectMovieId) {
      // ! 1
      movieIdRef.current = state?.movieId || selectedMovie?.id || searchMovieId || selectEventMovieId;
      // console.log("state?.movieId,selectedMovie?.id,searchMovieId,filteredMovies?.id,selectMovieId", state?.movieId, selectedMovie?.id, searchMovieId, filteredMovies?.[0]?.id, filteredMovies?.id, selectMovieId)
      // added selectMovieId because in upcoming when we reload data is not shown. because remain id becomes undefined
      getMovie(state?.movieId || selectMovieId || searchMovieId || filteredMovies?.id || filteredUpcomingMovies?.id || selectEventMovieId);
    } else {

      findMoviefilter(pathname.split('/')[2], { id: JSON.stringify({ shortURL: pathname.split('/')[2] }) }, { title: movieName?.substr(0, 8) });
    }
  }, [selectedMovie?.id, searchMovieId, selectEventMovieId, filteredMovies?.id, filteredUpcomingMovies?.id, selectMovieId, searchedMovies]);


  useEffect(() => {
    if (movieIdRef.current || location || searchMovieId || searchCinemaIdvalue || filteredMovies?.id || filteredUpcomingMovies?.id) {
      // ! 2
      // console.log("selectMovieId,movieIdRef.current", selectMovieId, movieIdRef.current);
      getDateList({ movieId: selectMovieId || movieIdRef.current || searchMovieId || selectedMovie?.id || filteredMovies?.id || filteredUpcomingMovies?.id, cinemaId: selectCinemaId || searchCinemaIdvalue });
    }

  }, [movieIdRef.current, location, searchMovieId, searchCinemaIdvalue, selectCinemaId]);

  const handleSessionId = () => {
    if (sessionId?.includes(",")) {
      const idSession = sessionId.split(",");

      return idSession;
    }

    return [sessionId];
  };

  useEffect(() => {
    setEventWebData(eventWeb)
  }, [eventWeb])


  useEffect(() => {
    if (process.env.REACT_APP_COUNTRY === "svn") {
      document.title = "Cineplexx | Film"
    }

    return () => {
      document.title = "Cineplexx"
    };
  }, [])

  useEffect(() => {
    const locationToCheck = savedLocation;

    if (!locations.length) {
      return;
    }

    if (
      locations.length &&
      !locations.some(l => l?.id?.toString() === locationToCheck) &&
      locationToCheck !== 'all'
    ) {
      saveLocation('all');
      urlSearchParams.set('location', 'all');
      history.replace({ search: `?${urlSearchParams.toString()}` });
    }
  }, [locations]);

  const onSelectLocation = useCallback(
    valueFromSelect => {
      if (!valueFromSelect || !valueFromSelect.length) return;

      const { value } = valueFromSelect[0];

      setRedLabelLocation(value !== 'all');

      if (
        value.toString() === urlSearchParams.get('location')
        && value.toString() === savedLocation
      ) {
        return;
      }

      saveLocation(value);
      urlSearchParams.set('location', value);
      urlSearchParams.set('cinemaId', '');
      setSearchCinemaIdvalue('');
      history.replace({ search: `?${urlSearchParams.toString()}` });
    },
    [urlSearchParams]
  );

  const onSelectCinema = useCallback(
    valueFromSelect => {
      if (!valueFromSelect || !valueFromSelect.length) return;
      const { value } = valueFromSelect[0];

      setRedLabelCinema(value !== 'all');

      if (
        value === urlSearchParams.get('cinemaId')
        && value === searchCinemaIdvalue
        && value === savedCinema
      ) {
        return;
      }

      setSearchCinemaIdvalue('');
      if (value !== 'all') {
        setSearchCinemaIdvalue(value);
      }
      urlSearchParams.set('cinemaId', value);
      history.replace({ search: `?${urlSearchParams.toString()}` });
    },
    [urlSearchParams]
  );


  useEffect(() => {
    if (
      (movieIdRef.current || selectMovieId || filteredMovies?.id || filteredUpcomingMovies?.id) &&
      date &&
      location &&
      // searchCinemaIdvalue &&
      ((isDateValid && !isDateExist) || (isDateValid && isDateExist)) &&
      !daily &&
      !eventId
    ) {
      // getSessions({ movieId: selectMovieId || movieIdRef.current || searchMovieId || selectMovieId || selectEventMovieId || searchCinemaIdvalue, date });
      // console.log("selectMovieId,movieIdRef.current,searchMovieId,selectEventMovieId,selectedMovie?.id,filteredMovies?.id", selectMovieId, movieIdRef.current, searchMovieId, selectEventMovieId, selectedMovie?.id, filteredMovies?.id)
      getSessions({ movieId: selectMovieId || movieIdRef.current || searchMovieId || selectEventMovieId || filteredMovies?.id || filteredUpcomingMovies?.id, date });
    }
  }, [movieIdRef.current, date, location, daily, eventId, searchMovieId, selectEventMovieId, filteredMovies?.id]);

  useEffect(() => {
    let fallBackDate = date;
    const isDateExist =
      !dates.length ||
      (date === 'all') ||
      dates.some(d => format(getDateWithOffset(d), 'yyyy-MM-dd') === date);

    if (!isDateValid || !isDateExist) {
      fallBackDate = getFallbackDate(dates);
      urlSearchParams.set('date', fallBackDate);

      history.replace({
        search: `?${urlSearchParams.toString()}`
      });
    }
  }, [date, dates, isDateValid, urlSearchParams]);

  useEffect(() => {
    const getEventId = (search?.split('=')[1]?.split("&")[1] === 'event' && (JSON.parse(localStorage.getItem("eventId")) === search?.split('=')[2]?.split('&')[0]?.replaceAll("+", " "))) ? JSON.parse(localStorage.getItem("eventId")) : search?.split('=')[1]?.split("&")[1] === 'event' ? search?.split('=')[2]?.split('&')[0]?.replaceAll("+", " ") : '';
    // const movieId = localStorage.getItem("movieId");
    // const movieId = sessionStorage.getItem("seletEventMovieId");
    const movieId = sessionStorage.getItem("seletEventMovieId") || selectMovieId || (filteredUpcomingMovies && filteredUpcomingMovies?.id) || (filteredMovies && (filteredMovies?.id));

    if (movieId && getEventId) {
      eventsWebFetch({ movieId, eventId: getEventId });
    }
    else {
      setEventWebData([])
    }
  }, [date, location, selectMovieId, filteredUpcomingMovies, filteredMovies]);
  useEffect(() => {
    setSessionCheckLength(daysSessions.every(element => element?.sessions?.length === 0));
  }, [daysSessions])

  useEffect(() => {
    setEventSessionCheckLength(eventWebData.every(element => element?.sessions?.length === 0));
  }, [eventWebData])

  useEffect(() => {
    if (
      (state?.selectCinema === true) ||
      (oldURL?.split(":")[2]?.slice(4)?.split("?")[0] === window?.location?.pathname) ||
      (oldURL?.split(":")[2]?.slice(4)?.split("?")[0] === undefined)
    ) {
      const id = selectCinemaId;

      setSelectCinemaIdvalue(id)
    }
    // else{
    //   sessionStorage.removeItem('cinemaId')
    //   setSelectCinemaIdvalue("")
    // }
  }, [oldURL, state?.selectCinema, selectCinemaId])

  useEffect(() => {
    sessionStorage.removeItem("movie");

    if (selectEventMovieId || searchMovieId) {
      localStorage.removeItem("seletEventMovieId");
      localStorage.removeItem("searchMovieId");
    }
  }, [selectEventMovieId, searchMovieId])

  const id = sessionStorage.getItem('cinemaId');

  const { redLabelDate, onSelectDate } = useDateSelector(date, onDateSelected);

  const [windowSize, setWindowSize] = useState();

  useEffect(() => {
    setWindowSize(window.innerWidth);
  }, [window])

  window.addEventListener('resize', function () {
    setWindowSize(window.innerWidth);
  }, true)

  const getSessionType = (pageType, sessions, daysSessions, movieDetails) => {
    if (pageType === "EVENT_SESSIONS") {
      const hasEventSessions = eventWeb.some(cinema =>
        cinema.sessions?.some(session => session.sessions?.length > 0)
      );
      return (!hasEventSessions) && "no-session";
    } else if (pageType === "DAILY_SESSIONS") {
      const hasSessions = daysSessions.some(cinema =>
        cinema.sessions?.some(session => session.sessions?.length > 0)
      );
      return (!hasSessions) && "no-session";
    }
    return "";
  };
  return (
    <SectionEntityDetails>
      {/* {
        !isMainTabVisible && false &&
        <div className="s-entity-details__nav-tabs">
          <NavTabsList>
            <NavTabsItem
              isSelected={isMainTabVisible}
              onClick={() => toggleTabs(true)}
              text={t("movies.showtimes")}
            />
            <NavTabsItem
              isSelected={!isMainTabVisible}
              onClick={() => toggleTabs(false)}
              text={t("movies.movie_details")}
            />
          </NavTabsList>
        </div>
      } */}
      <Container>
        <MainEntityDetails
          gallery={(!movieDetails?.trailers?.length && movieDetails?.gallery?.length)}
          isVisible={isMainTabVisible || true}
          type={getSessionType(pageType, sessions, daysSessions, movieDetails)}
        >
          <div className="fixed_movie_detail">
            {windowSize <= 992 ? (
              <Container>
                {((pageType === PAGE_TYPES.DAILY_SESSIONS && daysSessions.length) || (pageType === PAGE_TYPES.EVENT_SESSIONS && eventWebData?.length >= 0)) ? (
                  <div className="movie-detail">
                    <MoviesDatesFilter
                      locations={locations}
                      selectedLocation={location || savedLocation}
                      onSelectLocation={onSelectLocation}
                      redLabelLocation={redLabelLocation}
                      // dates={dates.length ? dates : date === 'all' ? [] : [date]}
                      // selectedDate={date}
                      onSelectDate={() => { }}
                    // redLabelDate={redLabelDate}
                    // isAsAllDates
                    // withAllDateOption
                    />
                  </div>
                ) : (id === null ? (
                  <MoviesDatesFilter
                    locations={locations}
                    selectedLocation={location || savedLocation}
                    onSelectLocation={onSelectLocation}
                    redLabelLocation={redLabelLocation}
                    dates={dates.length ? dates : [date]}
                    selectedDate={date}
                    onSelectDate={onSelectDate}
                    redLabelDate={redLabelDate}
                    className="movie-detail"
                  />
                ) : (
                  <MoviesDatesFilter
                    // locations={[]}
                    // selectedLocation={cinemasLocation || savedLocation}
                    onSelectLocation={() => { }}
                    // redLabelLocation={redLabelLocation}
                    dates={dates.length ? dates : [date]}
                    selectedDate={date}
                    onSelectDate={onSelectDate}
                    redLabelDate={redLabelDate}
                    className="movie-detail"
                  />))}

                {
                  movieDetails?.trailers ?
                    (
                      <VideoPoster
                        movieDetails={movieDetails}
                        isVisible={!isMainTabVisible}
                        isLoggedIn={isLoggedIn}
                        WatchListBtn={WatchListBtn}
                        EntityGallery={EntityGallery}
                        location={location}
                      />
                    )
                    :
                    (
                      <>
                        {movieDetails.id ? (
                          <Fragment>

                            <TitleWithPoster entityDetails={movieDetails} location={location}>
                              {isLoggedIn ? (
                                <WatchListBtn
                                  id={movieDetails.id}
                                  isInWatchList={movieDetails.isInWatchlist}
                                  isDetails
                                />
                              ) : null}
                            </TitleWithPoster>

                            {movieDetails.gallery && movieDetails.gallery.length ? (
                              <EntityGallery gallery={movieDetails.gallery} />
                            ) : null}

                          </Fragment>
                        ) : null}
                      </>
                    )
                }
              </Container>) : (
              <>
                {movieDetails.id ? (
                  <Fragment>

                    <TitleWithPoster entityDetails={movieDetails} location={location}>
                      {isLoggedIn ? (
                        <WatchListBtn
                          id={movieDetails.id}
                          isInWatchList={movieDetails.isInWatchlist}
                          isDetails
                        />
                      ) : null}
                    </TitleWithPoster>

                    {movieDetails.gallery && movieDetails.gallery.length ? (
                      <div style={{ paddingTop: "15px" }}>
                        <EntityGallery gallery={movieDetails.gallery} />
                      </div>
                    ) : null}

                  </Fragment>
                ) : null}
              </>
            )}

            <div className="s-entity-details__nav-tabs">
              <NavTabsList>
                <NavTabsItem
                  isSelected={isMainTabVisible}
                  onClick={() => toggleTabs(true)}
                  text={t("movies.showtimes")}
                />
                <NavTabsItem
                  isSelected={!isMainTabVisible}
                  onClick={() => toggleTabs(false)}
                  text={t("movies.movie_details")}
                />
              </NavTabsList>
            </div>
          </div>
          {(windowSize <= 992 ? isMainTabVisible : true) && (<>
            {((pageType === PAGE_TYPES.DAILY_SESSIONS && daysSessions.length && !sessionCheckLength) ||
              (pageType === PAGE_TYPES.EVENT_SESSIONS && eventWebData?.length >= 0 && !EventSessionCheckLength)) ? (
              <div className="movie-detail">
                <MoviesDatesFilter
                  cinemas={cinemas}
                  selectedCinema={cinemaId || savedCinema}
                  // selectedCinema={cinemaId}
                  onSelectCinema={onSelectCinema}
                  redLabelCinema={redLabelCinema}
                  onSelectDate={() => { }}
                  sessions={daysSessions}
                />
              </div>
            ) : null}

            {pageType === PAGE_TYPES.EVENT_SESSIONS && eventWebData?.length > 0 ? (
              <DailySessionView
                sessions={eventWebData}
                movieId={movieIdRef.current}
                movieTitle={movieDetails?.titleCalculated}
                cinemas={cinemas}
                isTrailerData={movieDetails?.trailers?.length}
                isgalleryData={(!movieDetails?.trailers?.length && movieDetails?.gallery?.length)}
              />
              // <EventCommonView
              //   movieId={movieIdRef.current}
              //   sessions={cinemasWithTickets}
              //   sess={eventWebData}
              //   cinemasLocation={location}
              //   savedLocation={savedLocation}
              //   onDateSelected={onDateSelected}
              //   onLocationSelected={onLocationSelected}
              // />
            ) : (
              // <CommonView
              //   movieId={movieIdRef.current}
              //   sessions={cinemasWithTickets}
              //   cinemasLocation={location}
              //   savedLocation={savedLocation}
              //   onDateSelected={onDateSelected}
              //   onLocationSelected={onLocationSelected}
              // />

              null)}

            {pageType === PAGE_TYPES.EVENT_SESSIONS && EventSessionCheckLength ? (
              <NoContent svgId="no-tickets" text={t("movies.no_sessions")} />
            ) : null}


            {pageType === PAGE_TYPES.COMMON && daysSessions.length > 0 && (
              <CommonView
                movieId={movieIdRef.current}
                sessions={cinemasWithTickets}
                sessionss={daysSessions}
                cinemasLocation={location}
                savedLocation={savedLocation}
                onDateSelected={onDateSelected}
                onLocationSelected={onLocationSelected}
                selectCinemaId={selectCinemaIdvalue ?? ""}
                savedCinema={savedCinema}
                getDateList={getDateList}
                history={history}
                movieTitle={movieDetails?.titleCalculated}
              />
            )}

            {pageType === PAGE_TYPES.COMMON && !cinemasWithTickets.length ? (
              <NoContent svgId="no-tickets" text={t("movies.no_sessions")} />
            ) : null}

            {/* SessionsDays with movie daily sessions in specified location cinemas */}
            {pageType === PAGE_TYPES.DAILY_SESSIONS && daysSessions.length ? (
              <DailySessionView
                sessions={daysSessions}
                movieId={movieIdRef.current}
                // movieTitle={movieDetails?.titleCalculated}
                movieTitle={movieDetails?.shortURL ? movieDetails?.shortURL : (i18n?.language === 'en' || i18n?.language === 'en-US' ? movieDetails?.titleOriginalCalculated : movieDetails?.titleCalculated)}
                cinemaSearchId={searchCinemaIdvalue}
                cinemas={cinemas}
                isTrailerData={movieDetails?.trailers?.length}
                isgalleryData={(!movieDetails?.trailers?.length && movieDetails?.gallery?.length)}
              />
            ) : null}

            {pageType === PAGE_TYPES.DAILY_SESSIONS && sessionCheckLength ? (
              <NoContent svgId="no-tickets" type="no-session" text={t("movies.no_sessions")} />
            ) : null}


            {/* CinemaSessionsView with movie sessions in specified location for particular day and cinema */}
            {pageType === PAGE_TYPES.CINEMA_SESSIONS && cinemaSessions ? (
              <CinemaSessionsView
                cinemaName={cinemaSessions.cinemaName}
                tickets={cinemaSessions.tickets.filter(ticket =>
                  handleSessionId().find(item => item === ticket.sessionId)
                )}
              />
            ) : null}

            {pageType === PAGE_TYPES.CINEMA_SESSIONS && !cinemaSessions ? (
              <NoContent svgId="no-tickets" text={t("movies.no_sessions")} />
            ) : null}
          </>)}
        </MainEntityDetails>

        <AsideMovieDetails
          movieDetails={movieDetails}
          isVisible={!isMainTabVisible}
          isLoggedIn={isLoggedIn}
          WatchListBtn={WatchListBtn}
          location={location}
          isEntityGalleryShown={windowSize <= 992}
        />

      </Container>
    </SectionEntityDetails>
  );
};

MovieDetails.propTypes = propTypes;
export default MovieDetails;
